<div
    class="statusTextCell {{getStatusClass(cell)}} p-2"
    [style.backgroundColor]="getStatusColor(cell)"
>
    <span class="fw-bold">{{getStatusLabel(cell)}}</span>
    <br />
    {{getStatusDate(cell) | date:'dd/MM/yyyy HH:mm'}}
</div>
